// extracted by mini-css-extract-plugin
export default {"container":"PatientInfo_container__kva0u","fieldsContainer":"PatientInfo_fieldsContainer__oAD9w","fields":"PatientInfo_fields__BtcWW"};